function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _temp;

var _require = require('@uppy/core'),
    UIPlugin = _require.UIPlugin;

var _require2 = require('preact'),
    h = _require2.h;

var _require3 = require('@uppy/companion-client'),
    RequestClient = _require3.RequestClient;

var toArray = require('@uppy/utils/lib/toArray');

var UrlUI = require('./UrlUI.js');

var forEachDroppedOrPastedUrl = require('./utils/forEachDroppedOrPastedUrl');

var locale = require('./locale');

function UrlIcon() {
  return h("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, h("g", {
    fill: "none",
    fillRule: "evenodd"
  }, h("rect", {
    className: "uppy-ProviderIconBg",
    fill: "#FF753E",
    width: "32",
    height: "32",
    rx: "16"
  }), h("path", {
    d: "M22.788 15.389l-2.199 2.19a3.184 3.184 0 0 1-.513.437c-.806.584-1.686.876-2.638.876a4.378 4.378 0 0 1-3.519-1.752c-.22-.292-.146-.802.147-1.021.293-.22.806-.146 1.026.146.953 1.313 2.785 1.532 4.105.583a.571.571 0 0 0 .293-.292l2.199-2.189c1.1-1.167 1.1-2.992-.073-4.086a2.976 2.976 0 0 0-4.105 0l-1.246 1.24a.71.71 0 0 1-1.026 0 .703.703 0 0 1 0-1.022l1.246-1.24a4.305 4.305 0 0 1 6.083 0c1.833 1.605 1.906 4.451.22 6.13zm-7.183 5.035l-1.246 1.24a2.976 2.976 0 0 1-4.105 0c-1.172-1.094-1.172-2.991-.073-4.086l2.2-2.19.292-.291c.66-.438 1.393-.657 2.2-.584.805.146 1.465.51 1.905 1.168.22.292.733.365 1.026.146.293-.22.367-.73.147-1.022-.733-.949-1.76-1.532-2.859-1.678-1.1-.22-2.272.073-3.225.802l-.44.438-2.199 2.19c-1.686 1.75-1.612 4.524.074 6.202.88.803 1.979 1.241 3.078 1.241 1.1 0 2.199-.438 3.079-1.24l1.246-1.241a.703.703 0 0 0 0-1.022c-.294-.292-.807-.365-1.1-.073z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
/**
 * Url
 *
 */


module.exports = (_temp = _class = /*#__PURE__*/function (_UIPlugin) {
  _inherits(Url, _UIPlugin);

  var _super = _createSuper(Url);

  function Url(uppy, opts) {
    var _this;

    _classCallCheck(this, Url);

    _this = _super.call(this, uppy, opts);
    _this.id = _this.opts.id || 'Url';
    _this.title = _this.opts.title || 'Link';
    _this.type = 'acquirer';

    _this.icon = function () {
      return h(UrlIcon, null);
    }; // Set default options and locale


    _this.defaultLocale = locale;
    var defaultOptions = {};
    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);

    _this.i18nInit();

    _this.hostname = _this.opts.companionUrl;

    if (!_this.hostname) {
      throw new Error('Companion hostname is required, please consult https://uppy.io/docs/companion');
    } // Bind all event handlers for referencability


    _this.getMeta = _this.getMeta.bind(_assertThisInitialized(_this));
    _this.addFile = _this.addFile.bind(_assertThisInitialized(_this));
    _this.handleRootDrop = _this.handleRootDrop.bind(_assertThisInitialized(_this));
    _this.handleRootPaste = _this.handleRootPaste.bind(_assertThisInitialized(_this));
    _this.client = new RequestClient(uppy, {
      companionUrl: _this.opts.companionUrl,
      companionHeaders: _this.opts.companionHeaders,
      companionCookiesRule: _this.opts.companionCookiesRule
    });
    return _this;
  }

  _createClass(Url, [{
    key: "getFileNameFromUrl",
    value: function getFileNameFromUrl(url) {
      return url.substring(url.lastIndexOf('/') + 1);
    }
  }, {
    key: "checkIfCorrectURL",
    value: function checkIfCorrectURL(url) {
      if (!url) return false;
      var protocol = url.match(/^([a-z0-9]+):\/\//)[1];

      if (protocol !== 'http' && protocol !== 'https') {
        return false;
      }

      return true;
    }
  }, {
    key: "addProtocolToURL",
    value: function addProtocolToURL(url) {
      var protocolRegex = /^[a-z0-9]+:\/\//;
      var defaultProtocol = 'http://';

      if (protocolRegex.test(url)) {
        return url;
      }

      return defaultProtocol + url;
    }
  }, {
    key: "getMeta",
    value: function getMeta(url) {
      var _this2 = this;

      return this.client.post('url/meta', {
        url: url
      }).then(function (res) {
        if (res.error) {
          _this2.uppy.log('[URL] Error:');

          _this2.uppy.log(res.error);

          throw new Error('Failed to fetch the file');
        }

        return res;
      });
    }
  }, {
    key: "addFile",
    value: function addFile(url) {
      var _this3 = this;

      url = this.addProtocolToURL(url);

      if (!this.checkIfCorrectURL(url)) {
        this.uppy.log("[URL] Incorrect URL entered: ".concat(url));
        this.uppy.info(this.i18n('enterCorrectUrl'), 'error', 4000);
        return;
      }

      return this.getMeta(url).then(function (meta) {
        var tagFile = {
          source: _this3.id,
          name: _this3.getFileNameFromUrl(url),
          type: meta.type,
          data: {
            size: meta.size
          },
          isRemote: true,
          body: {
            url: url
          },
          remote: {
            companionUrl: _this3.opts.companionUrl,
            url: "".concat(_this3.hostname, "/url/get"),
            body: {
              fileId: url,
              url: url
            },
            providerOptions: _this3.client.opts
          }
        };
        return tagFile;
      }).then(function (tagFile) {
        _this3.uppy.log('[Url] Adding remote file');

        try {
          return _this3.uppy.addFile(tagFile);
        } catch (err) {
          if (!err.isRestriction) {
            _this3.uppy.log(err);
          }

          return err;
        }
      }).catch(function (err) {
        _this3.uppy.log(err);

        _this3.uppy.info({
          message: _this3.i18n('failedToFetch'),
          details: err
        }, 'error', 4000);

        return err;
      });
    }
  }, {
    key: "canHandleRootDrop",
    value: function canHandleRootDrop(e) {
      var items = toArray(e.dataTransfer.items);
      var urls = items.filter(function (item) {
        return item.kind === 'string' && item.type === 'text/uri-list';
      });
      return urls.length > 0;
    }
  }, {
    key: "handleRootDrop",
    value: function handleRootDrop(e) {
      var _this4 = this;

      forEachDroppedOrPastedUrl(e.dataTransfer, 'drop', function (url) {
        _this4.uppy.log("[URL] Adding file from dropped url: ".concat(url));

        _this4.addFile(url);
      });
    }
  }, {
    key: "handleRootPaste",
    value: function handleRootPaste(e) {
      var _this5 = this;

      forEachDroppedOrPastedUrl(e.clipboardData, 'paste', function (url) {
        _this5.uppy.log("[URL] Adding file from pasted url: ".concat(url));

        _this5.addFile(url);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return h(UrlUI, {
        i18n: this.i18n,
        addFile: this.addFile
      });
    }
  }, {
    key: "install",
    value: function install() {
      var target = this.opts.target;

      if (target) {
        this.mount(target, this);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.unmount();
    }
  }]);

  return Url;
}(UIPlugin), _class.VERSION = "2.0.5", _temp);